import * as angular from 'angular';
import { ApiSettingsResource } from '../custom';

export interface ShipperResource
    extends ng.resource.IResourceClass<ng.resource.IResource<Shipper>>,
        ApiSettingsResource {
    queryPublic: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    loggedInShipper: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    get: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    save: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    changeContacts: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    getNumberOfShippers: ng.resource.IResourceMethod<
        ng.resource.IResource<any>
    >;
    getFutureShipper: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    channelConfig: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    channelConfigs: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    remitInfoLink: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    ascInfoLink: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    shippers: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    user: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    futureUser: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    futureShipperValidity: ng.resource.IResourceMethod<
        ng.resource.IResource<Interval>
    >;
    getShipperDetails: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    prepareUsersAsPdf: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    prepareUsersAsCsv: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    assignedOperators: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    assignedOperatorsForSpecificShipperUser: ng.resource.IResourceMethod<
        ng.resource.IResource<any>
    >;
    getDocuments: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    shipperPremiumServicesBillingAddress: ng.resource.IResourceMethod<
        ng.resource.IResource<ShipperPremiumServiceBillingAddressCreationDto>
    >;
    shipperPremiumServicesSubscription: ng.resource.IResourceMethod<
        ng.resource.IResource<ShipperPremiumServiceSubscriptionCreationDto>
    >;
    getShipperPremiumServicesSubscription: ng.resource.IResourceMethod<
        ng.resource.IResource<ShipperPremiumServiceSubscriptionCreationDto>
    >;
}

angular.module('app').factory('Shipper', shipperService);

function shipperService(
    $resource: ng.resource.IResourceService,
    API_URL
): ShipperResource {
    return <ShipperResource>$resource(
        API_URL.SHIPPERS,
        {},
        {
            queryPublic: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/public'
            },
            loggedInShipper: {
                method: 'GET',
                url: API_URL.SHIPPER
            },
            get: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/:id'
            },
            save: {
                method: 'POST'
            },
            changeContacts: {
                method: 'POST',
                url: API_URL.SHIPPERS + '/changeContacts'
            },
            getNumberOfShippers: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/registeredShipperCount'
            },
            futureShipperValidity: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/futureShipperValidity'
            },
            getFutureShipper: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/futureShipper'
            },
            channelConfig: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/channel-config'
            },
            channelConfigs: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/channel-configs',
                isArray: true
            },
            remitInfoLink: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/remit-info-link'
            },
            ascInfoLink: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/asc-info-link'
            },
            shippers: {
                method: 'GET',
                url: API_URL.SHIPPERS
            },
            user: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/:id/user',
                params: {
                    id: '@id'
                },
                isArray: true
            },
            futureUser: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/:id/futureUser',
                params: {
                    id: '@id'
                },
                isArray: true
            },
            getShipperDetails: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/user/:id',
                params: {
                    id: '@id'
                }
            },
            prepareUsersAsPdf: {
                method: 'POST',
                url: API_URL.SHIPPERS + '/:id/user/pdf/prepare',
                params: {
                    id: '@id'
                }
            },
            prepareUsersAsCsv: {
                method: 'POST',
                url: API_URL.SHIPPERS + '/:id/user/csv/prepare',
                params: {
                    id: '@id'
                }
            },
            assignedOperators: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/assigned-operators',
                isArray: true
            },
            assignedOperatorsForSpecificShipperUser: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/:id/assigned-operators',
                params: {
                    id: '@id'
                },
                isArray: true
            },
            getDocuments: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/:id/document',
                isArray: true
            },
            restApiSetEnabled: {
                method: 'POST',
                url: API_URL.SHIPPERS + '/:id/rest-api/enabled',
                params: {
                    id: '@id'
                }
            },
            restApiIsEnabled: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/:id/rest-api/enabled',
                params: {
                    id: '@id'
                },
                interceptor: {
                    response: function (res) {
                        return res.data;
                    }
                }
            },
            restApiToken: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/:id/rest-api/token',
                params: {
                    id: '@id'
                }
            },
            restApiSupported: {
                method: 'GET',
                url: API_URL.SHIPPERS + '/:id/rest-api/support-started',
                interceptor: {
                    response: function (res) {
                        return res.data;
                    }
                }
            }
        }
    );
}
